import axios from 'axios';
import { ElNotification, ElMessageBox } from 'element-plus';
import store from '@/store';

import Qs from 'qs';
// axios.defaults.baseURL =
//     import.meta.env.VITE_APP_BASE_API;
// // axios.defaults.baseURL = 'http://10.200.146.144:51030';
// axios.defaults.headers['X-Requested-With'] = 'XMLHttpRequest';

const ENV = import.meta.env;

const isLocal = location.host.includes('localhost');

const service = axios.create({
    baseURL: ENV.VITE_APP_BASE_API,
    // baseURL: '/web',
    headers: {
        'X-Requested-With': 'XMLHttpRequest',
        'Content-Type': 'application/json'
    }
});

// request拦截器
service.interceptors.request.use(
    config => {
        config.headers['cbs-token'] = localStorage.getItem('authToken'); // 让每个请求携带自定义token 请根据实际情况自行修改
        config.headers['gcpToken'] = localStorage.getItem('gcpToken'); // 新版登录跳转，兼容老的业务中台authToken
        const headersList = ['multipart/form-data;charset=UTF-8', 'application/json'];
        if (config.data && !headersList.includes(config.headers['Content-Type'])) {
            config.data = Qs.stringify(config.data);
        }
        return config;
    },
    error => {
        Promise.reject(error);
    }
);

// const NotCheckError = [ // 有些url直接不报错
//   '/it/finance/cost/report/export'
// ];

// response 拦截器
service.interceptors.response.use(
    res => {
        // 对流文件单独处理
        // res?.config?.responseType !== 'arraybuffer'
        if (res?.data?.code !== 'success' && res?.config?.responseType !== 'arraybuffer') {
            const errorMsg = res.data.message;
            if (res?.data?.code === 'user-not-login' || res?.data?.code === 801) {
                store.dispatch('LogIn');
                return;
            }
            if (errorMsg !== undefined) {
                ElNotification({
                    title: errorMsg,
                    type: 'error',
                    duration: 5000
                });
            }
            return Promise.reject(res.data);
        }
        return res.data;
    },
    error => {
        // 兼容blob下载出错json提示
        ElNotification({
            title: '接口请求失败',
            type: 'error',
            duration: 5000
        });
        return Promise.reject(error);
    }
);

export default service;
